import { CardMedia as MCardMedia, CardMediaProps } from '@mui/material'

interface CustomCardMediaProps extends CardMediaProps {
  component: React.ElementType
  alt: string
}

export const CardMedia: React.FC<CustomCardMediaProps> = ({ component, ...props }) => {
  return <MCardMedia component={component} {...props} />
}
